/*
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-15 19:32:27
 * @LastEditors: Luz Liu luz.liu@zoom.us
 * @LastEditTime: 2022-07-28 20:13:49
 * @FilePath: \async-component-ui\packages\components\unitConvert\index.js
 * @Description: ~
 */
import AsUnitConvert from './unitConvert'
AsUnitConvert.install = (Vue) => {
  Vue.component(AsUnitConvert.name, AsUnitConvert)
}

export default AsUnitConvert
